/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useSnackbar } from "hooks/useSnackbar";
import { useAuth } from "cms/auth/hooks/use-auth";
import { Dialog, CardContent, Card } from "@mui/material";
import { LinkContext } from "cms/links/link-selector/context";
import { LinkEditContext } from "cms/links/link-selector/context/edit";
import { LinkEditHeader } from "cms/links/link-selector/dialog-edit/panels/link-edit-header";
import { LinkDialogBottomActions } from "cms/links/link-selector/dialog-edit/actions/link-dialog-bottom-actions";
import { LinkEditPanel } from "cms/links/link-selector/dialog-edit/panels/link-edit-panel";

const LinkEditDialog = () => {

    const {
        link,
        setLink,
        openEdit,
        handleEditClose,
        handleTabsChange,
        selectedLink,
        setSelectedLink,
        MODES,
        setMode,
        localState,
        setLocalState,
        hasLink,
        selectedTab,
        setNeedsRefresh
    } =  useContext(LinkContext);
    
    const [canSave, setCanSave] = useState(false);
    
    const { token } = useAuth();
    const { showSnackbar } = useSnackbar();
    
    const onSelectLink = (e, link) => {
        e.stopPropagation();
        setSelectedLink(link);
    };
    const handleCancel = (e) => {
        handleEditClose(e);
    };
    const onSaveLink = (payload) => {
        if (payload) {
            setSelectedLink(payload);
            const guid = payload?.guid;
            SimpliCityAdminSDK.link.update(token, guid, payload)
                .then(() => {
                // setSelectedLink(link)
                    handleEditClose();
                    // reload list
                    setNeedsRefresh(true);
                });
        }
    };
    
    const LinkEditContextProps = {
        link,
        setLink,
        handleEditClose,
        selectedLink,
        setSelectedLink,
        onSelectLink,
        onSaveLink,
        MODES,
        setMode,
        handleTabsChange,
        hasLink,
        localState,
        setLocalState,
        selectedTab,
        canSave,
        setCanSave,
        showSnackbar,
    };
    
    return (
        <>
            <Dialog
                open={openEdit}
                onClose={handleCancel}
                fullWidth={true}
                maxWidth='lg'
                className="simplicity-link-selector-overlay edit"
            >
                <LinkEditContext.Provider value={LinkEditContextProps}>
                    <Card elevation={0} className="simplicity-link-edit-window">
                        <CardContent sx={{ flex: "1 0 auto", height: "100%", padding: 0 }}>
                            
                            <LinkEditHeader />

                            <div className="simplicity-link-edit-window-content">
                                <div className="simplicity-link-edit-window-active">
                                    <LinkEditPanel />
                                </div>
                            </div>
                            
                            {/*{enableDebug &&*/}
                            {/*    <pre style={{*/}
                            {/*        marginLeft: '24px', marginRight: '24px', fontSize: '10px', overflowY: 'scroll',*/}
                            {/*        height: '250px', width: '740px', border: '1px solid black'*/}
                            {/*    }}>*/}
                            {/*        {JSON.stringify(selectedLink,null,2)}*/}
                            {/*    </pre>*/}
                            {/*}*/}
                            
                        </CardContent>
                    </Card>
                    
                    <LinkDialogBottomActions />
                    
                </LinkEditContext.Provider>
            </Dialog>
        </>
    );
};

export { LinkEditDialog };
